export const COUNTRIES_TYPES = {
  GET_ALL_COUNTRIES: 'GET_ALL_COUNTRIES_BEGIN',
  GET_ALL_COUNTRIES_SUCCESS: 'GET_ALL_COUNTRIES_SUCCESS',
  GET_ALL_COUNTRIES_FAILURE: 'GET_ALL_COUNTRIES_FAILURE',
};
